/**
 * Ad Content Sanitizer - SECURITY UPDATED
 *
 * Now uses DOMPurify for comprehensive XSS protection.
 * Previous version only fixed SVG attributes - this version provides full HTML sanitization.
 */

import { sanitizeAdHtmlSync } from './htmlSanitizer';

/**
 * LEGACY FUNCTION - DEPRECATED
 * Use sanitizeAdHtmlSafe instead for proper security
 * @deprecated Use sanitizeAdHtmlSafe for secure HTML sanitization
 */
export function sanitizeAdHtml(html: string): string {
  return sanitizeAdHtmlSync(html);
}

/**
 * Secure ad HTML sanitization with XSS protection
 * @param html - The advertisement HTML content to sanitize
 * @returns Sanitized HTML safe for rendering with dangerouslySetInnerHTML
 */
export function sanitizeAdHtmlSafe(html: string): string {
  return sanitizeAdHtmlSync(html);
}

